// @flow
import AvailableInformers, { AvailableInformersView } from './AvailableInformers';

export default AvailableInformers;
export { AvailableInformersView };
